import React, { FC } from 'react';
import * as S from './styled';
import guarantee from './img/guarantee.png';

export const Guarantee: FC = props => {
	return (
		<S.Container>
			<S.Title>Money-Back Guarantee</S.Title>
			<S.Description>
				We are confident with our service quality and its results. So, if you are ready to reach
				your goals, it&apos;s a risk-free offer. We guarantee you&apos;ll see visible results or
				you&apos;ll receive a full refund within 30 days after your purchase. You will need to
				demonstrate that you have followed the program.
			</S.Description>
			<S.Policy>
				<p>
					Find more about the applicable limitations in our{' '}
					<a
						href='https://verv.com/vervapp-ios-terms-and-conditions-of-use/'
						target='_blank'
						rel='noreferrer'
					>
						money-back guarantee policy
					</a>
					.
				</p>
				<img src={guarantee} alt='Money-Back Guarantee' />
			</S.Policy>
		</S.Container>
	);
};
